/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantIntegrationChannel from './tenant-integration-channel';
import TenantIntegrationChannelDetail from './tenant-integration-channel-detail';
import TenantIntegrationChannelUpdate from './tenant-integration-channel-update';
import TenantIntegrationChannelDeleteDialog from './tenant-integration-channel-delete-dialog';

const TenantIntegrationChannelRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantIntegrationChannel />} />
    <Route path="new" element={<TenantIntegrationChannelUpdate />} />
    <Route path=":id">
      <Route index element={<TenantIntegrationChannelDetail />} />
      <Route path="edit" element={<TenantIntegrationChannelUpdate />} />
      <Route path="delete" element={<TenantIntegrationChannelDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantIntegrationChannelRoutes;
